import { isFeature } from 'Cloud/Application/FeaturesEs6';

/** https://jira.vk.team/browse/B2BCLOUD-3820 Применение прав для вложенных папок */
export const GP_NESTED_FOLDERS_ENABLED = isFeature('gp-nested-folders');
